import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WelcomeComponent } from './components/welcome/welcome/welcome.component';
import { LandingPageComponent } from './components/welcome/landing-page/landing-page.component';
import { ForgotPasswordComponent } from './components/security/forgot-password/forgot-password.component';
import { MenuComponent } from './components/security/menu/menu.component';
import { CommonModule } from '@angular/common';

import { AuthGuard } from './auth-guard';

const routes: Routes = [



  // welcome

  { path: '', component: WelcomeComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'logout', component: WelcomeComponent },


  { path: 'landingPage', component: LandingPageComponent , canActivate: [AuthGuard]},

  // insider
  { path: 'menu', component: MenuComponent },
  { path: 'forgotPassword', component: ForgotPasswordComponent },




  { path: 'admin', component: LandingPageComponent, canActivate: [AuthGuard],
    children:[
      {
        path: '',
        loadChildren: () => import('./modules/administration.module').then(m=> m.AdministrationModule)
      }
    ]
  
  },
  { path: 'logFrame', component: LandingPageComponent, canActivate: [AuthGuard],
    children:[
      {
        path: '',
        loadChildren: () => import('./modules/logFrame.module').then(m=> m.LogFrameModule)
      }
    ]
  
  },
  { path: 'setting', component: LandingPageComponent, canActivate: [AuthGuard],
    children:[
      {
        path: '',
        loadChildren: () => import('./modules/setting.module').then(m=> m.SettingModule)
      }
    ]
  
  },
  { path: 'report', component: LandingPageComponent, canActivate: [AuthGuard],
    children:[
      {
        path: '',
        loadChildren: () => import('./modules/report.module').then(m=> m.ReportModule)
      }
    ]
  
  },
 
  
  {path: '**', redirectTo: ''}


];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
